<template>
  <div class="rating">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'rating',
  data () {
    return {
      msg: 'Skapa ny öl provning'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// AddNew.vue?85a18c8e